import { render, staticRenderFns } from "./miqu_ios.vue?vue&type=template&id=8d055fd4&scoped=true&"
import script from "./miqu_ios.vue?vue&type=script&lang=js&"
export * from "./miqu_ios.vue?vue&type=script&lang=js&"
import style0 from "./miqu_ios.vue?vue&type=style&index=0&id=8d055fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d055fd4",
  null
  
)

export default component.exports